module.exports = __webpack_public_path__ + "img/1536528136.4fa596bb.jpg";